"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KetteCalculator = void 0;
const echain_math_1 = require("@igus/echain-math");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
/**
 * The 'KetteCalculator' provides all formulas related to ketten
 * on a very basic level without knowledge of domain model
 */
class KetteCalculator {
    static calcEffektiveLaenge(numGlieder, teilung) {
        return echain_shared_quantities_1.Length.mm(echain_math_1.KetteMath.calcEffektiveLaenge_mm(numGlieder, teilung.mm));
    }
    static calcEffektiveLaengeWithAE(numGlieder, teilung, aeLength) {
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(numGlieder),
            echain_shared_validation_1.Validator.definedNotNull(teilung),
            echain_shared_validation_1.Validator.definedNotNull(aeLength),
        ]);
        // eslint-disable-next-line
        return echain_shared_quantities_1.Length.mm(KetteCalculator.calcEffektiveLaenge(numGlieder, teilung).mm + aeLength.mm);
    }
    static calcESkinEffektiveLaengeWithAE(numGlieder, teilung, aeLength, aeExcessLength) {
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(numGlieder),
            echain_shared_validation_1.Validator.definedNotNull(teilung),
            echain_shared_validation_1.Validator.definedNotNull(aeLength),
            echain_shared_validation_1.Validator.definedNotNull(aeExcessLength),
        ]);
        // eslint-disable-next-line
        return echain_shared_quantities_1.Length.mm(KetteCalculator.calcEffektiveLaenge(numGlieder, teilung).mm + aeLength.mm - aeExcessLength.mm);
    }
    static calcLaenge(verfahrweg, k, versatz = echain_shared_quantities_1.Length.mm(0)) {
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(verfahrweg),
            echain_shared_validation_1.Validator.definedNotNull(k),
            echain_shared_validation_1.Validator.definedNotNull(versatz),
        ]);
        // eslint-disable-next-line
        return echain_shared_quantities_1.Length.mm(echain_math_1.KetteMath.calcLaenge_mm(verfahrweg.mm, k.mm, versatz.mm));
    }
    static calcESkinLaenge(verfahrweg, k, aeExcessLength, versatz = echain_shared_quantities_1.Length.mm(0)) {
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(verfahrweg),
            echain_shared_validation_1.Validator.definedNotNull(k),
            echain_shared_validation_1.Validator.definedNotNull(aeExcessLength),
            echain_shared_validation_1.Validator.definedNotNull(versatz),
        ]);
        // eslint-disable-next-line
        return echain_shared_quantities_1.Length.mm(echain_math_1.EskinMath.calcLaenge_mm(verfahrweg.mm, k.mm, aeExcessLength.mm, versatz.mm));
    }
    static calcLaengeWithLangerWeg(verfahrweg, k2, versatz = echain_shared_quantities_1.Length.mm(0)) {
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(verfahrweg),
            echain_shared_validation_1.Validator.definedNotNull(k2),
            echain_shared_validation_1.Validator.definedNotNull(versatz),
        ]);
        // eslint-disable-next-line
        return echain_shared_quantities_1.Length.mm(echain_math_1.KetteMath.calcLaengeWithLangerWeg_mm(verfahrweg.mm, k2.mm, versatz.mm));
    }
    static calcVerfahrweg(effektiveLaenge, k, versatz = echain_shared_quantities_1.Length.mm(0)) {
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(effektiveLaenge),
            echain_shared_validation_1.Validator.definedNotNull(k),
            echain_shared_validation_1.Validator.definedNotNull(versatz),
        ]);
        // eslint-disable-next-line
        return echain_shared_quantities_1.Length.mm(echain_math_1.KetteMath.calcVerfahrweg_mm(effektiveLaenge.mm, k.mm, versatz.mm));
    }
    static calcESkinVerfahrweg(effektiveLaenge, k, versatz = echain_shared_quantities_1.Length.mm(0), aeExcessLength = echain_shared_quantities_1.Length.mm(0)) {
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(effektiveLaenge),
            echain_shared_validation_1.Validator.definedNotNull(k),
            echain_shared_validation_1.Validator.definedNotNull(versatz),
            echain_shared_validation_1.Validator.definedNotNull(aeExcessLength),
        ]);
        // eslint-disable-next-line
        return echain_shared_quantities_1.Length.mm(echain_math_1.EskinMath.calcVerfahrweg_mm(effektiveLaenge.mm, k.mm, versatz.mm, aeExcessLength.mm));
    }
    static calcVerfahrwegWithLangerWeg(effektiveLaenge, k2, versatz = echain_shared_quantities_1.Length.mm(0)) {
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(effektiveLaenge),
            echain_shared_validation_1.Validator.definedNotNull(k2),
            echain_shared_validation_1.Validator.definedNotNull(versatz),
        ]);
        // eslint-disable-next-line
        return echain_shared_quantities_1.Length.mm(echain_math_1.KetteMath.calcVerfahrwegWithLangerWeg_mm(effektiveLaenge.mm, k2.mm, versatz.mm));
    }
    static calcNumGlieder(laenge, teilung) {
        echain_shared_validation_1.Validation.throws([echain_shared_validation_1.Validator.definedNotNull(laenge), echain_shared_validation_1.Validator.definedNotNull(teilung)]);
        // eslint-disable-next-line
        return echain_math_1.KetteMath.calcNumGlieder_1(laenge.mm, teilung.mm);
    }
    static calcNumGliederOdd(laenge, teilung) {
        echain_shared_validation_1.Validation.throws([echain_shared_validation_1.Validator.definedNotNull(laenge), echain_shared_validation_1.Validator.definedNotNull(teilung)]);
        const num = KetteCalculator.calcNumGlieder(laenge, teilung);
        return num % 2 === 0 ? num + 1 : num;
    }
    static calcGewicht(laenge, gewichtKgProM) {
        echain_shared_validation_1.Validation.throws([echain_shared_validation_1.Validator.definedNotNull(laenge), echain_shared_validation_1.Validator.definedNotNull(gewichtKgProM)]);
        // eslint-disable-next-line
        return echain_shared_quantities_1.Weight.kg(laenge.m * gewichtKgProM.kg_m);
    }
}
exports.KetteCalculator = KetteCalculator;
//# sourceMappingURL=KetteCalculator.js.map